import { useState } from "react";

const GALLERY = [
  {
    id: 1,
    title: "Modern Kitchen Deep Clean",
    category: "Deep Clean",
    img: "https://public.readdy.ai/ai/img_res/4384d3aae3e5f60d1d8aecc67f29d8cb.jpg",
    tall: true,
  },
  {
    id: 2,
    title: "Luxury Bathroom Refresh",
    category: "Residential",
    img: "https://readdy.ai/api/search-image?query=immaculate%20pristine%20luxury%20bathroom%20after%20professional%20cleaning%20gleaming%20white%20marble%20tiles%20polished%20chrome%20fixtures%20sparkling%20glass%20shower%20crystal%20clear%20mirror%20bright%20clean%20fresh%20atmosphere%20simple%20background&width=600&height=500&seq=gallery2&orientation=landscape",
    tall: false,
  },
  {
    id: 3,
    title: "Corporate Office Suite",
    category: "Commercial",
    img: "https://readdy.ai/api/search-image?query=spotless%20clean%20modern%20corporate%20office%20suite%20polished%20hardwood%20floors%20dust%20free%20desks%20organised%20workspace%20bright%20lighting%20panoramic%20windows%20minimal%20clean%20professional%20atmosphere%20simple%20background&width=600&height=500&seq=gallery3&orientation=landscape",
    tall: false,
  },
  {
    id: 4,
    title: "Living Room Transformation",
    category: "Residential",
    img: "https://readdy.ai/api/search-image?query=beautiful%20freshly%20cleaned%20bright%20living%20room%20plush%20sofa%20fresh%20cushions%20gleaming%20glass%20coffee%20table%20polished%20wood%20floor%20dust%20free%20surfaces%20natural%20light%20streaming%20windows%20cozy%20clean%20atmosphere%20simple%20background&width=600&height=800&seq=gallery4&orientation=portrait",
    tall: true,
  },
  {
    id: 5,
    title: "Move-Out Apartment",
    category: "Move-Out",
    img: "https://readdy.ai/api/search-image?query=completely%20clean%20empty%20apartment%20after%20move%20out%20professional%20cleaning%20spotless%20empty%20rooms%20pristine%20floors%20walls%20fresh%20paint%20white%20clean%20minimalist%20bright%20ready%20for%20new%20tenant%20simple%20background&width=600&height=500&seq=gallery5&orientation=landscape",
    tall: false,
  },
  {
    id: 6,
    title: "Window & Glass Cleaning",
    category: "Windows",
    img: "https://readdy.ai/api/search-image?query=crystal%20clear%20streak%20free%20floor%20to%20ceiling%20windows%20after%20professional%20window%20cleaning%20bright%20city%20skyline%20view%20reflection%20free%20glass%20interior%20light%20filled%20room%20clean%20simple%20background&width=600&height=500&seq=gallery6&orientation=landscape",
    tall: false,
  },
];

const CATEGORIES = ["All", "Deep Clean", "Residential", "Commercial", "Move-Out", "Windows"];

export default function Gallery() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [lightbox, setLightbox] = useState<number | null>(null);

  const filtered =
    activeCategory === "All" ? GALLERY : GALLERY.filter((g) => g.category === activeCategory);

  return (
    <section id="gallery" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-teal-600 mb-3 block">
              Our Work
            </span>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-gray-900"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Completed Projects
            </h2>
          </div>
          <p className="text-gray-500 text-sm max-w-sm">
            Every job is our best job. Browse our portfolio of recent cleaning projects.
          </p>
        </div>

        {/* Filter tabs */}
        <div className="flex items-center gap-2 mb-8 flex-wrap">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? "bg-teal-600 text-white"
                  : "bg-white border border-stone-200 text-gray-600 hover:border-teal-400"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Masonry Grid */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 space-y-4">
          {filtered.map((item) => (
            <div
              key={item.id}
              className="break-inside-avoid relative overflow-hidden rounded-2xl group cursor-pointer"
              onClick={() => setLightbox(item.id)}
            >
              <div className={`w-full overflow-hidden ${item.tall ? "h-72 md:h-96" : "h-52 md:h-64"}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-5">
                <span className="text-xs bg-teal-500 text-white px-2.5 py-0.5 rounded-full w-fit mb-2">
                  {item.category}
                </span>
                <p className="text-white font-semibold text-sm">{item.title}</p>
                <div className="w-5 h-5 flex items-center justify-center mt-2">
                  <i className="ri-zoom-in-line text-white/70 text-base" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button
            onClick={() => document.querySelector("#booking")?.scrollIntoView({ behavior: "smooth" })}
            className="bg-teal-600 hover:bg-teal-700 text-white font-semibold px-8 py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            Book Your Cleaning
          </button>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-6 cursor-pointer"
          onClick={() => setLightbox(null)}
        >
          <div
            className="relative max-w-3xl w-full rounded-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={GALLERY.find((g) => g.id === lightbox)?.img}
              alt=""
              className="w-full h-auto max-h-[80vh] object-cover object-top"
            />
            <button
              onClick={() => setLightbox(null)}
              className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-black/50 hover:bg-black/80 text-white rounded-full cursor-pointer"
            >
              <i className="ri-close-line" />
            </button>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-5">
              <p className="text-white font-semibold text-sm">
                {GALLERY.find((g) => g.id === lightbox)?.title}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
